import { addLocaleData } from 'react-intl';

import enLocaleData from 'react-intl/locale-data/en';
import esLocaleData from 'react-intl/locale-data/es';

import en from '../locales/en';
import es from '../locales/es';

addLocaleData(enLocaleData);
addLocaleData(esLocaleData);

const translationMessages = {
  en,
  es,
};

export default translationMessages;
